import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { GetInfoAndPassService } from "src/app/services/get-info-and-pass.service";

@Component({
    selector: "app-suggested-delegates",
    templateUrl: "./suggested-delegates.component.html",
    styleUrls: ["./suggested-delegates.component.scss"],
    standalone: false
})
export class SuggestedDelegatesComponent implements OnInit {
  @Input() relation: string;
  @Output() removeSuggestion: EventEmitter<void> = new EventEmitter<void>();
  constructor(
    private router: Router,
    private getInfoAndPass: GetInfoAndPassService
  ) {}

  ngOnInit(): void {}

  addADelegate(relation) {
    console.log("relation clicked - ", relation);
    this.getInfoAndPass.getInfoAndPass(relation);
    this.router.navigate(["/dynamicformdataentry/delegate_1"]);
  }

  onRemoveSuggestionClick() {
    console.log("Remove suggestion button clicked");
    this.removeSuggestion.emit();
  }
}
